<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'exhibitors'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <div class="row pd-t50 exhibitor-backoffice-sub-header" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
      <div class="col-lg-10">
        <h1>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.TITLE' | translate }}</h1>
      </div>
    </div>

    <div class="exhibitor-backoffice__content">

      <form name="form" class="form" #form="ngForm">

        <div class="row">
          <div class="col">
            <div class="form-group" [ngClass]="{ 'has-error': name.invalid && (name.dirty || name.touched), 'has-success': name.valid }">
              <label for="name">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.NAME_LABEL' | translate }}</label>
              <input type="text" maxlength="255" required noWhitespace class="form-control" [(ngModel)]="exhibitorData['name']" name="name" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.NAME_PLACEHOLDER' | translate }}" #name="ngModel">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group" [ngClass]="{ 'has-error': sapId.invalid && (sapId.dirty || sapId.touched), 'has-success': sapId.valid }">
              <label for="sapId">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.SAP_ID_LABEL' | translate }}</label>
              <input type="text" maxlength="255" noWhitespace class="form-control" [(ngModel)]="exhibitorData['sapId']" name="sapId" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.SAP_ID_PLACEHOLDER' | translate }}" #sapId="ngModel">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group" [ngClass]="{ 'has-error': user.invalid && (user.dirty || user.touched), 'has-success': user.valid }">
              <label for="user">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.USER_LABEL' | translate }}</label>
              <input type="text" maxlength="255" required noWhitespace class="form-control" [(ngModel)]="exhibitorData['user']" name="user" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.USER_PLACEHOLDER' | translate }}" #user="ngModel">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group" [ngClass]="{ 'has-error': email.invalid && (email.dirty || email.touched), 'has-success': email.valid }">
              <label for="email">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.EMAIL_LABEL' | translate }}</label>
              <input type="text" required noWhitespace class="form-control" [(ngModel)]="exhibitorData['email']" name="email" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.EMAIL_PLACEHOLDER' | translate }}" #email="ngModel">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group" [ngClass]="{ 'has-error': orderSapId.invalid && (orderSapId.dirty || orderSapId.touched), 'has-success': orderSapId.valid }">
              <label for="orderSapId">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.ORDER_SAP_ID_LABEL' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="exhibitorData['orderSapId']" name="orderSapId" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.ORDER_SAP_ID_PLACEHOLDER' | translate }}" #orderSapId="ngModel">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group" [ngClass]="{ 'has-error': fatherOrderSapId.invalid && (fatherOrderSapId.dirty || fatherOrderSapId.touched), 'has-success': fatherOrderSapId.valid }">
              <label for="fatherOrderSapId">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.FATHER_ORDER_SAP_ID_LABEL' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="exhibitorData['fatherOrderSapId']" name="fatherOrderSapId" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.FATHER_ORDER_SAP_ID_PLACEHOLDER' | translate }}" #fatherOrderSapId="ngModel">
            </div>
          </div>
        </div>
        
        <div class= "row mt-3" *ngIf="activeMultiEvents">
          <div class="col">
            <div class="form-group" [ngClass]="{ 'has-error': fatherMultiId.invalid && (fatherMultiId.dirty || fatherMultiId.touched), 'has-success': fatherMultiId.valid }">
              <label for="fatherMultiId">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.SUB_CATALOGUE' | translate }}</label>
              <select class="form-control" [(ngModel)]="selectedMultiEvent" #fatherMultiId="ngModel" [ngModelOptions]="{standalone: true}">
                <option *ngFor="let event of multiEvent"
                [ngValue]="event">{{ event.label }} ( {{ event.sapCode }} )</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group" [ngClass]="{ 'has-error': published.invalid && (published.dirty || published.touched), 'has-success mg-b20': published.valid }">
              <div>
                <label for="published">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_CREATE.PUBLISHED_LABEL' | translate }}</label>
              </div>

              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" [(ngModel)]="exhibitorData['published']" name="optPublished" [value]="true" required #published="ngModel">
                  {{ 'COMMON.YES' | translate }}
                </label>
              </div>
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" [(ngModel)]="exhibitorData['published']" name="optPublished" [value]="false" required #published="ngModel">
                  {{ 'COMMON.NO' | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <button type="button" class="btn btn--submit float-end" (click)="saveBtn()" [disabled]="!form.valid" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
              {{ 'COMMON.SAVE' | translate }}
            </button>
            <button type="button" class="btn btn--light float-end mx-sm-3" (click)="cancel()">
              {{ 'COMMON.CANCEL' | translate }}
            </button>
          </div>
        </div>

      </form>
    </div>

  </div>
</div>

<app-footer></app-footer>
